// library imports
import { useEffect, useState, useContext } from "react";
import { Card, Col, Row, Skeleton } from "antd";
// config imports
import { MQTT_REFRESH_RATE } from "../../configs/configs";
// context imports
import { IndexContext } from "../../context/IndexContext";
// hook imports
import useFetch from "../../hooks/useFetch";
// component imports
import WeekdaySchedule from "../../components/ai_bess/WeekdaySchedule";

function AIBESSPage() {
  const [fetchWrapper] = useFetch();
  const { notificationApi, siteSelected } = useContext(IndexContext);

  const [aiBessStatus, setAIBESSStatus] = useState(null); // true means AIE-DR is on and vice versa
  const [aiBessStatusFirstLoad, setAIBESSStatusFirstLoad] = useState(true);

  /** API to get AIE-DR status */
  function getAIBESSStatus() {
    fetchWrapper({
      endpoint_url: "ai_bess/getAIBESSStatus",
      method: "GET",
      set_content_type_header: false,
      params: {
        site_id: siteSelected,
      },
      onSuccess: (response) => {
        setAIBESSStatus(response.data.status);
      },
      onResponseError: (response) => {
        notificationApi.error({
          message: "Failed to get AIE-DR status.",
          description: response.statusText,
        });
      },
      onFinish: () => {
        setAIBESSStatusFirstLoad(false);
      },
    });
  }

  useEffect(() => {
    if (siteSelected) {
      getAIBESSStatus();
      const timer = setInterval(() => {
        getAIBESSStatus();
      }, MQTT_REFRESH_RATE * 1000);
      return () => {
        clearInterval(timer);
      };
    }
  }, [siteSelected]);

  return aiBessStatusFirstLoad ? (
    <Card
      title={"AIE-DR Control"}
      size="small"
      style={{
        marginLeft: "10px",
        marginRight: "10px",
        height: "100%",
      }}
    >
      <Skeleton
        active={true}
        style={{ padding: "1rem", maxWidth: "90%", margin: "auto" }}
        paragraph={{ rows: 5 }}
      />
    </Card>
  ) : (
    <Card
      title={"AIE-DR Control"}
      size="small"
      style={{
        marginLeft: "10px",
        marginRight: "10px",
        height: "100%",
      }}
    >
      <Row style={{ width: "100%" }}>
        <Col span={12} style={{ textAlign: "right", padding: "0px 8px" }}>
          AIE-DR Status:
        </Col>
        <Col
          span={12}
          style={{
            color:
              aiBessStatus === true
                ? "green"
                : aiBessStatus === "-"
                ? "orange"
                : "red",
            fontWeight: "bold",
            padding: "0px 8px",
          }}
        >
          {aiBessStatus === true
            ? "ON"
            : aiBessStatus === "-"
            ? "UNKNOWN"
            : "OFF"}
        </Col>
      </Row>

      <h1>Workday Schedule</h1>

      <WeekdaySchedule />
    </Card>
  );
}

export default AIBESSPage;
